export const SELECT_CITY = 'SELECT_CITY'
export const SELECT_STORE = 'SELECT_STORE'
export const LOGIN = 'LOGIN'
export const PASSWORD_RECOVERY = 'PASSWORD_RECOVERY'
export const REGISTER = 'REGISTER'
